import { render, staticRenderFns } from "./DemographicQuestionnaire.vue?vue&type=template&id=2934c7fa"
import script from "./DemographicQuestionnaire.vue?vue&type=script&lang=js"
export * from "./DemographicQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports